import { MessageKey } from '../../i18n';
import { RING_DRILLS } from '../../sim/levels/ring';
import { laneLocal } from '../../sim/levels/zielonka';
import { DRILL_CONFIG } from '../config';
import { BaseDrill, DrillResult, Stars, frontAxle, round } from '../drill';
import { FrameState } from '../frame';

const C = DRILL_CONFIG.brake;
const G = RING_DRILLS.brake;

/** Drill 2: reach 40 km/h and stop with the front wheel as close to the line as possible, front unlocked. */
export class BrakeDrill extends BaseDrill {
  readonly id = 'brake' as const;
  readonly start = 'brake';
  protected readonly timeLimit = C.timeLimit;
  peak = 0;
  braking = false;
  locked = false;
  distance = Infinity;
  /** Signed: + stopped past the line, - short of it (the how-to card tells early from late braking). */
  past = 0;

  protected shouldStart(f: FrameState) { return f.input.throttle > 0 || Math.abs(f.bike.telemetry.speed) > 0.5; }

  protected metrics() {
    return { speed: round(this.peak * 3.6, 1), distance: round(this.distance), past: round(this.past) };
  }

  protected track(f: FrameState): DrillResult | null {
    const b = f.bike;
    const v = b.telemetry.speed;
    this.peak = Math.max(this.peak, v);
    if (b.telemetry.frontLock) this.locked = true;
    if (Math.abs(laneLocal(G, b.position.x, b.position.z).side) > G.halfWidth + C.laneMargin) return this.fail('result.reason.leftLane');
    if (Math.max(f.input.brake, f.input.frontBrake ?? 0, f.input.rearBrake ?? 0) > C.brakeOn) this.braking = true; // either lever, or the one brake
    if (!this.braking || Math.abs(v) > C.stopSpeed) return null;

    const front = frontAxle(f, this.cfg);
    this.past = laneLocal(G, front.x, front.z).along - G.length;
    this.distance = Math.abs(this.past);
    if (this.peak < C.minSpeed) return this.fail('result.reason.tooSlow');
    const t = C.tiers;
    let stars: Stars = this.distance <= t[3].maxDistance ? 3 : this.distance <= t[2].maxDistance ? 2 : this.distance <= t[1].maxDistance ? 1 : 0;
    const reasons: MessageKey[] = [];
    if (this.locked) {
      reasons.push('result.reason.frontLock');
      stars = Math.min(stars, C.lockMaxStars) as Stars;
    }
    if (this.distance > t[3].maxDistance) reasons.push('result.reason.distance');
    return { stars, metrics: this.metrics(), reasons };
  }
}
